import me from "models/me";
import { fetchRecentOrders } from "../recent-orders-actions";
import { BUYER_DASHBOARD_RECENT_ORDERS_REORDER, RECENT_ORDERS } from "constants/action-types";

export function fetchDashboardRecentOrders(params, next) {
    return (dispatch, getState) => {
        if (!me.isSignedIn()) {
            return [];
        }

        const { buyerDashboard } = getState();

        if (!buyerDashboard.connectedBrands.length) {
            dispatch({ type: RECENT_ORDERS.UPDATE, payload: [] });
        } else {
            dispatch(fetchRecentOrders({ ...params, removeActiveBrand: true }, next));
        }
    };
}

export const reorderRecentOrder = (payload) => ({
    payload,
    type: BUYER_DASHBOARD_RECENT_ORDERS_REORDER,
});
